import styles from "./RichText.module.css";

const RichText = ({ data }: { data: string }) => (
  <div
    className={styles.pageDescription}
    dangerouslySetInnerHTML={{ __html: data }}
  />
);

export default RichText;
